import Content from "../services/Content";

export default {
    props: ['initialProducts', 'tagSlug', 'total', 'profileSlug'],

    data: () => { return {
        products: {},
        tag: '',
        currentPage: 0,
        isLoading: false,
        profile: ''
    }},

    mounted: function() {

        this.products = this.initialProducts;
        if (this.tagSlug === '') {
            this.tag = 'all';
        } else {
            this.tag = this.tagSlug;
        }

        this.profile = this.profileSlug ? this.profileSlug : 'consumidor';

    },

    /*created() {
        this.$root.$on('bv::scrollspy::activate', this.onActivateScrollSpy)
    },*/

    methods: {
        getNextProductPage: function () {
            this.isLoading = true;
            this.currentPage += 1;
            Content.GetProductsBySearchPage(this.tag, this.currentPage, this.profile)
                .then((res) => {
                    this.isLoading = false;
                    this.products = this.products.concat(res.data);
                    this.$forceUpdate();
                })
                .catch((err) => {
                    this.isLoading = false;
                })
        },

        /*onActivateScrollSpy(target) {

            if (this.products.length >= this.total) {
                return;
            }

            let pageId = parseInt(target.replace('#product-', ''));

            //Check if is view in the last 4 pages
            if (
                pageId === this.products[this.products.length - 1].id ||
                pageId === this.products[this.products.length - 2].id ||
                pageId === this.products[this.products.length - 3].id ||
                pageId === this.products[this.products.length - 4].id ||
                pageId === this.products[this.products.length - 5].id ||
                pageId === this.products[this.products.length - 6].id
            ) {
                this.getNextProductPage();
            }
        },*/
        tagClassValue: function (slug) {
            return 'tag-' + slug;
        }
    },
}
